import { z } from "zod";

/**
 * path: ルーティングのパス
 * category: Backendが要求するカテゴリ
 */
export const SoftwareAlertType = {
  noWorker: {
    key: "noWorker",
    path: "no-worker",
    category: "NO_WORKER",
  },
  violatedAssignment: {
    key: "violatedAssignment",
    path: "violated-assignment",
    category: "VIOLATED",
  },
  violatedRole: {
    key: "violatedRole",
    path: "violated-role",
    category: "VIOLATED_ROLE",
  },
  noUser: {
    key: "noUser",
    path: "no-user",
    category: "NO_USER",
  },
  inactive: {
    key: "inactive",
    path: "inactive-user",
    category: "INACTIVE",
  },
  alumni: {
    key: "alumni",
    path: "alumni",
    category: "ALUMNI",
  },
} as const;

export type SoftwareAlertCategory =
  (typeof SoftwareAlertType)[keyof typeof SoftwareAlertType]["category"];
export type SoftwareAlertType = keyof typeof SoftwareAlertType;

export const SearchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
});

export type SearchParams = z.infer<typeof SearchSchema>;
